export enum SwitchboardLimitType {
  CUBICLE_LIMIT_TYPE = 'CUBICLE',
  FUNCTIONAL_UNIT_LIMIT_TYPE = 'FUNCTIONAL_UNIT'
}
